import React from "react";
import PropTypes from "prop-types";
import { formatPerc } from "../../utils/dataHelpers/formatters";

const BarLabel = ({ x, y, width, stroke, value, displayPercent }) => {
  const displayValue = displayPercent ? formatPerc(value * 100) : value;
  return (
    <text
      x={x + width / 2}
      y={y}
      dy={-10}
      fill={stroke}
      fontSize={16}
      textAnchor="middle"
    >
      {displayValue}
    </text>
  );
};

BarLabel.defaultProps = {
  x: null,
  y: null,
  width: null,
  stroke: null,
  value: null,
  displayPercent: false,
};

BarLabel.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  stroke: PropTypes.number,
  value: PropTypes.number,
  displayPercent: PropTypes.bool,
};
export default BarLabel;
